import React from 'react';
import { MetricTips1 } from './index';

const BasicDemo: React.FC = () => {
  return (
    <MetricTips1
      dataSource="sensortower"
      metric="revenue"
      description="该指标表示应用在指定时间段内的总收入（预估），为扣除平台分成前的毛收入。"
    />
  );
};

const WithEntityTypeDemo: React.FC = () => {
  return (
    <MetricTips1
      dataSource="appannie"
      metric="downloads"
      description="该指标表示应用在指定时间段内的总下载量的预估值，包括新增下载和更新下载。"
      entityType="combine"
    />
  );
};

export const demoConfig = [
  {
    title: '基础用法',
    description: '传入 dataSource、metric、description 即可展示指标提示内容',
    code: `<MetricTips1
  dataSource="sensortower"
  metric="revenue"
  description="该指标表示应用在指定时间段内的总收入（预估），为扣除平台分成前的毛收入。"
/>`,
    element: <BasicDemo />,
  },
  {
    title: '指定实体类型',
    description: '通过 entityType 属性指定实体类型，影响数据源名称的展示',
    code: `<MetricTips1
  dataSource="appannie"
  metric="downloads"
  description="该指标表示应用在指定时间段内的总下载量的预估值，包括新增下载和更新下载。"
  entityType="combine"
/>`,
    element: <WithEntityTypeDemo />,
  },
];

export default demoConfig;
